import { render, staticRenderFns } from "./AddProductToOrder.vue?vue&type=template&id=5c6b1b73&"
import script from "./AddProductToOrder.vue?vue&type=script&lang=js&"
export * from "./AddProductToOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports